var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "refRichTextMenu", staticClass: "rich-text-menu" }, [
    _c("div", { staticClass: "menu-container" }, [
      _vm.editor
        ? _c(
            "div",
            { staticClass: "menu" },
            [
              _vm._l(_vm.filteredOptions, function(option, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.getOptionClass(option) },
                  [
                    option === "SellsyAI" && _vm.isSellsyAIEnabled
                      ? [
                          _c("SellsyAIMenu", {
                            attrs: {
                              editor: _vm.editor,
                              option: option,
                              disabled: _vm.disabled,
                              typeRichText: _vm.typeRichText,
                              source: "richtextmenu"
                            }
                          }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "divider" })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Attachment"
                      ? _c("AttachmentRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled,
                            attachmentEndpoint: _vm.attachmentEndpoint,
                            hash: _vm.hash
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Heading"
                      ? _c("HeadingRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Size"
                      ? _c("SizeRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "TextAlign"
                      ? _c("TextAlignRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Link"
                      ? _c("LinkRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Image" || option === "ImageResizable"
                      ? _c("ImageRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "CustomTags"
                      ? _c("CustomTagsRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "CustomTagsAndFields"
                      ? _c("CustomTagsAndFieldsRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled,
                            refRichText: _vm.refRichText
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Color"
                      ? _c("ColorRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    option === "Highlight"
                      ? _c("HighlightRichText", {
                          attrs: {
                            editor: _vm.editor,
                            option: option,
                            disabled: _vm.disabled
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShowOption(option)
                      ? _c(
                          "CompassMenu",
                          {
                            attrs: {
                              placement: "top",
                              trigger: "click",
                              customClass: "custom-menu-container-more",
                              disabled: _vm.disabled
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "dropdown",
                                  fn: function() {
                                    return _vm._l(option.slice(1), function(
                                      subOption,
                                      subIndex
                                    ) {
                                      return _c(
                                        "CompassTooltip",
                                        {
                                          key: subOption + subIndex,
                                          attrs: {
                                            placement: "right",
                                            delay: { show: 0, hide: 1 },
                                            disabled: _vm.disabled
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function() {
                                                  return [
                                                    _vm.getExtensionOption(
                                                      subOption
                                                    ).label
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                _vm.getExtensionOptionLabel(
                                                                  subOption
                                                                )
                                                              ) +
                                                              "\n                                "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.getExtensionOption(
                                                      subOption
                                                    ).shortcuts
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "option-shortcuts"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                    " +
                                                                _vm._s(
                                                                  _vm.getExtensionOptionShortcuts(
                                                                    subOption
                                                                  )
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          option[0] === "More"
                                            ? _c("CompassIconButton", {
                                                attrs: {
                                                  icon: _vm.getExtensionOptionIcon(
                                                    subOption
                                                  ),
                                                  size: "small",
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm
                                                      .getExtensionOption(
                                                        subOption
                                                      )
                                                      .action()
                                                  }
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          option[0] === "Specific"
                                            ? _c(
                                                "CompassMenuItem",
                                                {
                                                  staticClass:
                                                    "custom-menu-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm
                                                        .getExtensionOption(
                                                          subOption
                                                        )
                                                        .action()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("CompassIcon", {
                                                    attrs: {
                                                      icon: _vm.getExtensionOptionIcon(
                                                        subOption
                                                      ),
                                                      size: "small"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "typographies-paragraph-small-regular"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.getExtensionOptionLabel(
                                                              subOption
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    })
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  content: _vm.getExtensionOptionLabel(
                                    option[0]
                                  ),
                                  placement: "top",
                                  delay: { show: 0, hide: 1 },
                                  disabled: _vm.disabled
                                }
                              },
                              [
                                _c("CompassIconButton", {
                                  attrs: {
                                    icon: _vm.getExtensionOptionIcon(option[0]),
                                    size: "small",
                                    disabled: _vm.disabled,
                                    active: _vm.activeStyle(option[0])
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : !_vm.allCustomOptions.includes(option) &&
                        option !== null
                      ? _c(
                          "CompassTooltip",
                          {
                            attrs: {
                              placement: "top",
                              delay: { show: 0, hide: 1 },
                              disabled: _vm.disabled
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function() {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getExtensionOptionLabel(option)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option-shortcuts" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.getExtensionOptionShortcuts(
                                                  option
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("CompassIconButton", {
                              attrs: {
                                icon: _vm.getExtensionOptionIcon(option),
                                size: "small",
                                disabled: _vm.disabled,
                                active: _vm.activeStyle(option)
                              },
                              on: {
                                click: function($event) {
                                  _vm.getExtensionOption(option).action()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : option === "Divider"
                      ? [_c("hr", { staticClass: "divider" })]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.$slots["more-custom-options"]
                ? _c("div", [_vm._t("more-custom-options")], 2)
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.actions
        ? _c("div", { staticClass: "menu-action" }, [_vm._t("actions")], 2)
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.$slots["more-block"]
      ? _c(
          "div",
          { staticClass: "richtext-more-block" },
          [_vm._t("more-block")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }